// This file is auto-generated by @hey-api/openapi-ts

import type {
  CreateKnowledgeBaseResponse,
  GetKnowledgeBaseResponse,
  GetWorkflowResponse,
  GetWorkflowsResponse,
  ListKnowledgeBaseFilesResponse,
  QueryActionsForNodeResponse,
  UpdateKnowledgeBaseResponse,
} from "./types.gen";

const knowledgeBaseSchemaResponseTransformer = (data: any) => {
  data.files = data.files.map((item: any) => {
    item.uploadedAt = new Date(item.uploadedAt);
    return item;
  });
  return data;
};

export const createKnowledgeBaseResponseTransformer = async (
  data: any,
): Promise<CreateKnowledgeBaseResponse> => {
  data = knowledgeBaseSchemaResponseTransformer(data);
  return data;
};

export const getKnowledgeBaseResponseTransformer = async (
  data: any,
): Promise<GetKnowledgeBaseResponse> => {
  data = knowledgeBaseSchemaResponseTransformer(data);
  return data;
};

export const updateKnowledgeBaseResponseTransformer = async (
  data: any,
): Promise<UpdateKnowledgeBaseResponse> => {
  data = knowledgeBaseSchemaResponseTransformer(data);
  return data;
};

export const listKnowledgeBaseFilesResponseTransformer = async (
  data: any,
): Promise<ListKnowledgeBaseFilesResponse> => {
  data = data.map((item: any) => {
    item.uploadedAt = new Date(item.uploadedAt);
    return item;
  });
  return data;
};

const queryActionForNodeSchemaResponseTransformer = (data: any) => {
  if (data.lastRun) {
    data.lastRun = new Date(data.lastRun);
  }
  data.outputMappings = data.outputMappings.map((item: any) => {
    if (item.lastRun) {
      item.lastRun = new Date(item.lastRun);
    }
    return item;
  });
  return data;
};

export const queryActionsForNodeResponseTransformer = async (
  data: any,
): Promise<QueryActionsForNodeResponse> => {
  data = data.map((item: any) =>
    queryActionForNodeSchemaResponseTransformer(item),
  );
  return data;
};

const workflowSchemaResponseTransformer = (data: any) => {
  data.timestamp = new Date(data.timestamp);
  return data;
};

export const getWorkflowsResponseTransformer = async (
  data: any,
): Promise<GetWorkflowsResponse> => {
  data = data.map((item: any) => workflowSchemaResponseTransformer(item));
  return data;
};

export const getWorkflowResponseTransformer = async (
  data: any,
): Promise<GetWorkflowResponse> => {
  data = workflowSchemaResponseTransformer(data);
  return data;
};
